const AD_CAMPAIGNS = {
  playground: {
    PJMasks2017: {
      id: 'PJMasks2017',
      link: 'http://pjmasks.com/grown-ups',
      customCharacterLink: 'http://pjmasks.com/grown-ups',
      customCharacter: 'PJMasks2017.png',
      customAd: 'PJMasks2017.png',
      viewCount: 0,
    },
    PJMasks201712: {
      id: 'PJMasks201712',
      link: 'http://pjmasks.com/grown-ups/apps',
      customCharacterLink: 'http://pjmasks.com/grown-ups',
      customCharacter: 'PJMasks201712.png',
      customAd: 'PJMasks201712.png',
      viewCount: 0,
    },
    BenHolly2017: {
      id: 'BenHolly2017',
      link: 'http://us.benandholly.tv/grown-ups',
      customCharacterLink: 'http://us.benandholly.tv/',
      customCharacter: 'BenHolly2017.png',
      customAd: 'BenHolly2017.png',
      viewCount: 0,
    },
    PJMasks201804: {
      id: 'PJMasks201804',
      link: 'http://pjmasks.com/grown-ups',
      customCharacterLink: 'http://pjmasks.com/grown-ups',
      customCharacter: 'PJMasks201804.png',
      customAd: 'PJMasks201804.png',
      viewCount: 0,
    },
  },
  hero: {
    AdaptedMinds2017: {
      id: 'AdaptedMinds2017',
      title: 'Monster Math Adventure',
      dek: `Help your monster go on a fun math adventure where you explore new worlds, meet new characters and find treasure!`,
      link: `/games/monster-math-adventure`,
      customGameSlug: 'monster-math-adventure',
      imageURI:
        'https://www.funbrain.com/assets/img/content-cards/9bDoo5L9Q9ORfHeGMjyq_math-monster-adventure.png',
      mediaType: 'game',
    },
    TinybopSchools201809: {
      id: 'TinybopSchools201809',
      title: 'Coral Reef',
      dek: `Explore underwater with sea creatures.`,
      link: `/games/tinybop-schools-coral-reef`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchools201809-2.png',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    TinybopSchoolsSimpleMachines: {
      id: 'TinybopSchoolsSimpleMachines',
      title: 'Simple Machines',
      dek: `Explore the playful side of physics.`,
      link: `/games/tinybop-schools-simple-machines`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchools201809.png',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    TinybopSchoolsEarth: {
      id: 'TinybopSchoolsEarth',
      title: 'The Earth',
      dek: `Dig into our planet and the forces that shape it.`,
      link: `/games/tinybop-schools-earth`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchoolsTheEarth.jpg',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    TinybopSchoolsMammals: {
      id: 'TinybopSchools202003',
      title: 'Mammals',
      dek: `Discover how these amazing animals live.`,
      link: `/games/tinybop-schools-mammals`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchoolsMammals.jpg',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    TinybopSchoolsSpace: {
      id: 'TinybopSchools202003',
      title: 'Space',
      dek: `Explore our solar system`,
      link: `/games/tinybop-schools-space`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchoolsSpace.png',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    TinybopSchoolsHumanBody: {
      id: 'TinybopHumanBody',
      title: 'The Human Body',
      dek: `See what we’re made of and how we work.`,
      link: `/games/tinybop-schools-human-body`,
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/TinybopSchoolsHumanBody.jpg',
      sponsoredBugText: ' ',
      logoImageURI:
        'https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png',
      mediaType: 'game',
    },
    LoneStars2017: {
      id: 'LoneStars2017',
      title: 'Lone Stars',
      dek:
        'Clay is never more at home than when playing football. His coach—a former Dallas Cowboys player, is like a second father. But when football season starts, Clay notices odd behavior from coach, and is determined to find out what’s wrong.',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/LoneStars2017.png',
      buttonLabel: 'Read Now',
      externalLink:
        'https://ad.doubleclick.net/ddm/trackclk/N115602.927FUNBRAIN.COM/B20271701.204664359;dc_trk_aid=404445616;dc_trk_cid=92644319;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
      impressionTrackingURI:
        'https://ad.doubleclick.net/ddm/trackimp/N115602.927FUNBRAIN.COM/B20271701.204664359;dc_trk_aid=404445616;dc_trk_cid=92644319;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
    },
    BenHolly2017: {
      id: 'BenHolly2017',
      title: 'Ben & Holly’s Castle',
      dek:
        'No kingdom is complete without your very own castle! Live the royal life with this 2-story Deluxe 12” Little Castle playset, featuring exclusive Holly, Daisy, and Poppy figures, and 10 fun accessories. It all fits inside for easy tidy-up!',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/BenHolly2017.png',
      sponsoredBugText: 'Sponsored by',
      buttonLabel: 'Shop',
      externalLink:
        'https://www.target.com/p/ben-holly-s-deluxe-castle-playset/-/A-52236681#lnk=sametab',
    },
    ShipOfTheDead2017: {
      id: 'ShipOfTheDead2017',
      title: 'The Ship of the Dead',
      dek:
        'In the third book of Rick Riordan’s Norse mythology series, Magnus journeys to the farthest borders of Jotunheim and Niflheim in pursuit of Asgard’s greatest threat. Life preservers are mandatory for this wet, wild, and wondrous adventure.',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/ShipOfTheDead2017.png',
      buttonLabel: 'Buy',
      externalLink:
        'https://www.amazon.com/Magnus-Chase-Gods-Asgard-Book/dp/1423160932?tag=dpw009-20',
    },
    MrLemoncello2017: {
      id: 'MrLemoncello2017',
      title: 'Mr. Lemoncello’s Library',
      dek:
        'Based on the best-selling novel, the Nickelodeon TV Movie Event follows 12 kids as they solve puzzles, find clues, and outrun danger at every turn as they compete to Escape From Mr. Lemoncello’s Library!',
      imageURI:
        'https://cdn.funbrain.com/assets/img/sponsors/hero/MrLemoncello2017.jpg',
      buttonLabel: 'Watch Trailer',
      externalLink:
        'https://ad.doubleclick.net/ddm/trackclk/N444804.2783201SANDBOXNETWORKINC/B20338603.205919628;dc_trk_aid=405659909;dc_trk_cid=93364745;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
      impressionTrackingPixel: `<IMG SRC="https://ad.doubleclick.net/ddm/trackimp/N444804.2783201SANDBOXNETWORKINC/B20338603.205919628;dc_trk_aid=405659909;dc_trk_cid=93364745;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?" BORDER="0" HEIGHT="1" WIDTH="1" ALT="Advertisement">
<SCRIPT TYPE="application/javascript" SRC="https://pixel.adsafeprotected.com/rjss/st/113244/18641520/skeleton.js"></SCRIPT>
<NOSCRIPT><IMG SRC="https://pixel.adsafeprotected.com/rfw/st/113244/18641519/skeleton.gif" BORDER=0 WIDTH=1 HEIGHT=1 ALT=""></NOSCRIPT>`,
    },
    MagicMisfits2017: {
      id: 'MagicMisfits2017',
      title: 'THE MAGIC MISFITS',
      dek:
        'From Neil Patrick Harris comes the magical first book in a new series with plenty of tricks up its sleeve.',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/MagicMisfits2017.png',
      buttonLabel: 'Start Reading',
      sponsoredBugText: 'Sponsored by Little, Brown Books for Young Readers',
      externalLink:
        'https://ad.doubleclick.net/ddm/trackclk/N7384.927FUNBRAIN.COM0/B20474973.209373082;dc_trk_aid=409061178;dc_trk_cid=95237965;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
      impressionTrackingURI:
        'https://ad.doubleclick.net/ddm/trackimp/N7384.927FUNBRAIN.COM0/B20474973.209373082;dc_trk_aid=409061178;dc_trk_cid=95237965;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
    },
    BadKitty201801: {
      id: 'BadKitty201801',
      title: 'BAD KITTY CAMP DAZE',
      dek:
        'Bad Kitty is off to camp in the latest hilarious adventure in the bestselling Bad Kitty series!',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/BadKitty201801.png',
      buttonLabel: 'Start Reading',
      sponsoredBugText: 'Sponsored by  Macmillan Children’s Publishing Group',
      externalLink:
        'http://www.badkittybooks.com/books/bad-kitty-camp-daze/?utm_source=poptropica&utm_medium=adsiteskin&utm_term=funbrain-badkittytakeover&utm_content=na-read-announcement&utm_campaign=9781626728851',
    },
    ArloFinch201802: {
      id: 'ArloFinch201802',
      title: 'ARLO FINCH IN THE VALLEY of FIRE',
      dek:
        'Join Arlo Finch and his magical and dangerous adventure in Book 1 of a new fantasy trilogy!',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/ArloFinch201802.png',
      sponsoredBugText: 'Sponsored by Mac Kids',
      buttonLabel: 'Start Reading',
      externalLink:
        'http://arlofinchbooks.com/?utm_source=funbrain&utm_medium=customplacement&utm_term=na-shopnowad&utm_content=na-buy-buynow&utm_campaign=9781626728141',
    },
    JudyMoody201804: {
      id: 'JudyMoody201804',
      title: 'Judy Moody Was In A Mood',
      dek:
        'Bad moods, good moods, and every mood in between – Judy Moody has them all! Learn more about Judy Moody and check out way-not-boring stuff!',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/JudyMoody201804.png',
      sponsoredBugText: 'Sponsored by Candlewick Press',
      buttonLabel: 'Go now',
      externalLink: 'http://www.candlewick.com/r/judy-funbrain',
    },
    PeppaPig201804: {
      id: 'PeppaPig201804',
      title: 'World of Peppa Pig App',
      dek:
        'This oinktastic new app offers children a world of interactive fun! With new activities and games releasing every 2 weeks, the excitement never ends with Peppa Pig!',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/hero/PeppaPig201804.png',
      sponsoredBugText: 'Sponsored by Entertainment One',
      buttonLabel: 'Find out more',
      externalLink: 'http://www.peppapig.com/world-of-peppa-pig-app/',
    },
    PartOfHarryMoonBanner: {
      id: 'PartOfHarryMoonBanner',
      title: null,
      link: null,
      dek: `Read the Harry Moon and Honey Moon series and learn how to become an everyday hero!`,
      buttons: [
        {
          text: 'View Series',
          to: '/harry-moon',
          buttonContext: 'hero',
          withAction: true,
        },
        {
          text: 'Buy the books',
          externalLink: 'https://harrymoon.com/collections/all',
          withAction: true,
          actionIcon: 'buy',
          buttonContext: 'buy',
        },
      ],
      imageURI:
        'https://www.funbrain.com/assets/img/harry-moon/HarryMoon_Hero_TitleOnly.png',
      sponsoredBugText: ' ',
      buttonLabel: 'Buy the books',
      externalLink: 'https://harrymoon.com/collections/all',
      items: [],
    },
    PartOfMonsterMeBanner: {
      id: 'PartOfMonsterMeBanner',
      title: 'Calling All Monster Makers!',
      externalLink: 'https://www.ipopstories.com/monster-me-contest',
      dek:
        'Enter to win prizes & receive a free Digital comic - all for a good cause!',
      buttons: [
        {
          text: 'Enter to Win!',
          externalLink: 'https://www.ipopstories.com/monster-me-contest',
          withAction: true,
          // actionIcon: 'buy',
          buttonContext: 'hero',
        },
        {
          text: 'Read more Monster Me books',
          to: '/monster-me',
          buttonContext: 'hero',
          withAction: true,
          actionIcon: 'read',
        },
      ],
      imageURI:
        'https://www.funbrain.com/assets/img/monster-me/monster-me-contest.png',
      items: [],
    },
    HarryMoonSeries: {
      id: 'HarryMoonSeries',
      title: 'The Harry Moon and Honey Moon Book Series',
      dek:
        'Every day is Halloween night in Sleepy Hollow! Harry Moon and his sister Honey Moon are up to their eyeballs in magic!',
      link: `/harry-moon`,
      buttonLabel: 'View series',
      imageURI:
        'https://www.funbrain.com/assets/img/harry-moon/HarryMoon_Hero.png',
      sponsoredBugText: ' ',
      items: [],
      mediaType: 'book',
    },
    HarryMoonLanding: {
      id: 'HarryMoonLanding',
      title: 'Harry Moon: Wand Paper Scissors',
      dek: `Harry Moon's archenemy, Titus Kligore, has eyes on winning the Annual Scary Talent Show. Harry has a tough job ahead if he is going to steal the crown.`,
      link: `/books/harry-moon-wand-paper-scissors/page/1`,
      sponsoredBugText: ' ',
      imageURI:
        'https://www.funbrain.com/assets/img/harry-moon/HarryMoon_Hero_TitleOnly.png',
      mediaType: 'book',
      buttonLabel: 'Read now',
      items: [],
    },
  },
  backgroundSkin: {
    LoneStars2017: {
      id: 'LoneStars2017',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/LoneStars2017.jpg',
      externalLink:
        'https://ad.doubleclick.net/ddm/trackclk/N115602.927FUNBRAIN.COM/B20271701.204623291;dc_trk_aid=404459797;dc_trk_cid=92588703;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
      impressionTrackingURI:
        'https://ad.doubleclick.net/ddm/trackimp/N115602.927FUNBRAIN.COM/B20271701.204623291;dc_trk_aid=404459797;dc_trk_cid=92588703;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
      routes: ['/books', '/games'],
    },
    MagicMisfits2017: {
      id: 'MagicMisfits2017',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/MagicMisfits2017.jpg',
      externalLink:
        'https://ad.doubleclick.net/ddm/trackclk/N7384.927FUNBRAIN.COM0/B20474973.209374693;dc_trk_aid=409061178;dc_trk_cid=95237965;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=',
      impressionTrackingURI:
        'https://ad.doubleclick.net/ddm/trackimp/N7384.927FUNBRAIN.COM0/B20474973.209374693;dc_trk_aid=409061178;dc_trk_cid=95237965;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=?',
      routes: ['/books'],
    },
    BadKitty201801: {
      id: 'BadKitty201801',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/BadKitty201801.jpg',
      externalLink:
        'http://www.badkittybooks.com/books/bad-kitty-camp-daze/?utm_source=poptropica&utm_medium=adsiteskin&utm_term=funbrain-badkittytakeover&utm_content=na-read-announcement&utm_campaign=9781626728851',
      routes: ['/books', '/games'],
    },
    ShipOfTheDead2017: {
      id: 'ShipOfTheDead2017',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/ShipOfTheDead2017.jpg',
      externalLink:
        'https://www.amazon.com/Magnus-Chase-Gods-Asgard-Book/dp/1423160932?tag=dpw009-20',
      routes: ['/books', '/games'],
    },
    ArloFinch201802: {
      id: 'ArloFinch201802',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/ArloFinch201802.png',
      externalLink:
        'http://arlofinchbooks.com/?utm_source=funbrain&utm_medium=customplacement&utm_term=na-shopnowad&utm_content=na-buy-buynow&utm_campaign=9781626728141',
      routes: ['/books', '/games'],
    },
    JudyMoody201804: {
      id: 'JudyMoody201804',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/JudyMoody201804.png',
      backgroundColor: '#62bb46',
      externalLink: 'http://www.candlewick.com/r/judy-funbrain',
      routes: ['/books', '/games'],
    },
    TinybopSchools201809: {
      id: 'TinybopSchools201809',
      imageURI:
        'https://www.funbrain.com/assets/img/sponsors/skin/TinybopSchools201809.png',
      backgroundColor: '#62bb46',
      externalLink:
        'https://schools.tinybop.com/?utm_source=funbrain&utm_campaign=201812_promo&utm_medium=skin',
      routes: ['/games/tinybop-schools-simple-machines'],
    },
  },
  mathZone: {},
};

export const ACTIVE_AD_CAMPAIGNS = {
  playground: undefined,
  homepageHero: undefined,
  gamesLandingHero: undefined,
  harryMoonLandingHero: AD_CAMPAIGNS.hero.HarryMoonLanding,
  harryMoonBookHero: AD_CAMPAIGNS.hero.PartOfHarryMoonBanner,
  monsterMeBookHero: AD_CAMPAIGNS.hero.PartOfMonsterMeBanner,
  videosLandingHero: undefined,
  booksLandingHero: undefined,
  backgroundSkin: AD_CAMPAIGNS.backgroundSkin.TinybopSchools201809,
  mathZone: undefined,
};
